// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"d17e9fc4","277":"ed4d4114","284":"364a99d4","316":"4ea193c4","595":"e2570589","661":"56fe6d7e","829":"843abd87","881":"d7c10fbc","955":"e36c087a"}[chunkId] + ".chunk.js";
};